import declare from "dojo/_base/declare";
import BrowseAttributesStore from "csi/prefs/BrowseAttributesStore";
import ExtendedPath from "csi/core/ExtendedPath";
import RefFilterController from "csi/heading/RefFilterController";
import reflection from "csi/reflection";
import xml from "csi/xml";
import AbstractPathBrowserStore from "csi/data/AbstractPathBrowserStore";

const QueryFilterController = declare(RefFilterController, {

	/**
	 * Get start type for attribute store path
	 */
	_getStartType(): string {
		return "Document";
	},

	/**
	 * @override
	 * Return store with allowed attributes (required)
	 */
	getAttributesStore(): AbstractPathBrowserStore {
		const startType = this._getStartType();
		const store = new BrowseAttributesStore(reflection.getClass(startType), null);
		const path = ExtendedPath.create(startType, xml.path(reflection.ATTR_CURRENT_REVISION));
		store.addTopLevelItemsFromPath(path);

		return store;
	},
});

export = QueryFilterController;
